import { ComponentView, ObservableArray, View } from "binder"
import { SidebarViewModel } from "./sidebar-viewModel"
import { SidebarItemViewModel } from "./sidebarItem/sidebarItem-viewModel";

export class SidebarView extends ComponentView<SidebarViewModel>{
    GetViewUniqueId(): string {
        return "V-A39816AC-EB57-484B-B189-4C57CCC71DFC"
    }
    loadHtml(): string {
        let element = require('./sidebar.html').default;
        let style = require('./sidebar.less');
        return element;
    }
    constructor() {
       super();
    }

    public set internalItems(v: ObservableArray<SidebarItemViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<SidebarItemViewModel> { return this._internalItems;} private _internalItems: ObservableArray<SidebarItemViewModel>;

}


